import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M20 6H16.97L14.55 3.59C14.18 3.21 13.67 3 13.14 3H10.86C10.33 3 9.82 3.21 9.45 3.59L7.03 6H4C2.9 6 2 6.9 2 8V17C2 18.1 2.9 19 4 19H20C21.1 19 22 18.1 22 17V8C22 6.9 21.1 6 20 6ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM19.09 9.47C18.54 9.47 18.09 9.02 18.09 8.47C18.09 7.92 18.54 7.47 19.09 7.47C19.65 7.47 20.09 7.92 20.09 8.47C20.09 9.02 19.65 9.47 19.09 9.47Z"
      fill="currentColor"
    />
    <path
      d="M15.25 12C15.25 13.795 13.795 15.25 12 15.25C10.205 15.25 8.75 13.795 8.75 12C8.75 10.205 10.205 8.75 12 8.75C13.795 8.75 15.25 10.205 15.25 12Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'CameraFill');

export default Icon;
